import { createApp } from 'vue'
import App from './App.vue'
import '@kinky-vibes/ui/styles.css'
import './docs.css'

createApp(App).mount('#app')
